import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { IBasicInfo, IFundraiser } from 'src/app/shared/models/fundraiser.model';
import { PaymentUtilService } from '../../../common/payment/services';
import { ICurrency } from '../../../shared/models/currency.model';
import { IUser } from '../../../shared/models/user.model';
import {
  EventsService,
  FbService,
  FundraiserService,
  ScriptLoaderService,
  SeoService,
  StorageService,
  UtilService,
  VariablesService
} from '../../../shared/services';
import { UtmPopupComponent } from './../utm-popup/utm-popup.component';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  @ViewChild('youtubeEmbed') public youtubeEmbed: ElementRef<HTMLElement>;
  isMobile: any;
  fundraiser: IFundraiser;
  customTag;
  updates;
  comments;
  currencyInfo: ICurrency;
  currency;
  paymentCurrency;
  isLoggedIn: boolean;
  donationCard;
  sharyCard;
  isDonated: boolean;
  userData: IUser;
  isFundraiserEnded: boolean;
  isSuccessfullyFunded: boolean;
  basicInfo = {} as IBasicInfo;
  tickrIsShown: boolean;
  beneficiary;
  theaterImage;
  sharedCounts = {
    fb: 0,
    whatsapp: 0
  };
  campaignUrl;
  videoSrc;
  currencySubscription: Subscription;
  actRouteSubs;
  tags;
  lastScrollTop = 0;
  today = new Date();
  inViewPort = {
    'docs': false,
    'comments': false,
    'twitter': false,
    'expense': false
  };
  varaibles = {
    showDonorImpact: true,
  };
  qParams;
  paymentDialogType = 'onpage';
  donationTitle = 'Stories.donations.chooseAmtToDonate';
  validLanguages = ['en', 'hi', 'ta', 'te', 'ar', 'ur'];
  initialTransalation = true;
  currentLanguage = 'en';
  translateObs;
  tabIndex = 0;

  subs: Subscription[] = [];
  readMoreStoryBtn = false;
  hide_el = true;
  eminentExpandEventSend = false;
  eminentVisible = true;
  birthdayloader = true;

  constructor(
    public actRoute: ActivatedRoute,
    public util: UtilService,
    private fundraiserService: FundraiserService,
    public vars: VariablesService,
    private seoService: SeoService,
    private fbService: FbService,
    public scriptLoaderService: ScriptLoaderService,
    public eventsService: EventsService,
    public dialog: MatDialog,
    private paymentUtilService: PaymentUtilService,
    public storage: StorageService,
    public bottomSheet: MatBottomSheet
  ) {
    this.vars.mainLayoutConfig.next({
      showSecure: true,
      showHeader: true,
      animateHeader: false,
      showCurrency: true,
      logoNavigate: true,
      headerClass: ''
    });
  }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.translateObs = this.vars.languageObs.subscribe((currentLang: any) => {
      this.currentLanguage = currentLang;
      if (!this.initialTransalation) {
        this.getFundraiser(this.customTag, this.currency || 'INR');
      }
    });
    this.util.scrollToTop();
    this.checkUserLogin();
    this.getParam();
    this.vars.campaignType = 'stories';

    this.subs.push(this.paymentUtilService.paymentCurrency.subscribe(currency => {
      this.paymentCurrency = currency;
    }));
    if (!this.vars.clickedAnywhere && typeof window !== 'undefined') {
      document.addEventListener('click', () => {
        this.vars.clickedAnywhere = true;
      });
    }
    setTimeout(() => {
      this.birthdayloader = false;
    }, 3000);
  }

  /**Get the params from URL */
  getParam() {
    const qParams = this.actRoute.snapshot.queryParams;
    const sessionLang = this.storage.getFromSession('language');
    if (qParams.hasOwnProperty('hide_el')) {
      this.hide_el = !qParams.hide_el;
    }
    if (qParams['type'] === 'lead') {
      this.paymentDialogType = 'lead';
      this.donationTitle = 'Stories.donations.provideWithDetails';
      this.vars.paymentDialogType.next('lead');
    }
    if (qParams['st'] === 'f' && !this.vars.thirdPartyApp) {
      this.paymentUtilService.isSubmitted.next(true);
      if (this.storage.get('walletOffer100')) {
        this.paymentUtilService.utmProceedClicked = true;
      }
    }
    if (qParams['selected_currency'] && this.isMobile && !qParams['st']) {
      this.paymentUtilService.isSubmitted.next(true);
    }
    if (qParams['lang'] && this.validLanguages.includes(qParams['lang'])) {
      this.vars.languageObs.next(qParams['lang']);
      this.vars.tranlatedLanguage = qParams['lang'];
      this.storage.addSessionData('language', qParams?.lang);
    } else if (sessionLang) {
      this.vars.tranlatedLanguage = sessionLang;
      this.vars.languageObs.next(sessionLang);
    }


    this.actRoute.params.subscribe((params) => {
      this.customTag = params['tag'];
      this.seoService.createAmpHtml('stories', this.customTag);
      this.util.isBrowser ? this.getCurrency() : this.getFundraiser(this.customTag, 'INR');
    });
    this.actRouteSubs = this.actRoute.queryParams.subscribe((params) => {
      this.qParams = params;
      if (!params.payment || ((!this.isMobile && (params.payment && params.payment === 'form')))) {
        if (!this.vars.qrOpened) {
          this.dialog.closeAll();
        }
      }
    });
  }

  openUtmPopup(): void {
    this.dialog.open(UtmPopupComponent, {
      maxWidth: '100%',
      width: '284px',
      panelClass: 'utm-popup',
      data: {
        campaignId: this.fundraiser.id,
        name: this.fundraiser.campaigner.fname
      }
    });
  }

  /**check user logged in status */
  checkUserLogin() {
    this.util.isLoggedIn.subscribe((res) => {
      this.isLoggedIn = res;
    });
    this.vars.userData.subscribe({
      next: (res) => {
        if (typeof window !== 'undefined' && res) {
          this.userData = res;
        }
      }
    });
  }

  afterLoggedInChecks(campaignId) {
    const qParams = this.actRoute.snapshot.queryParams;
    if (qParams['shby'] && qParams['utm_content']) {
      this.getSharyCardDetails(campaignId, qParams['utm_content']);
    }
    if (this.userData) {
      this.getDonorCardDetails(campaignId, this.userData.id);
    } else {
      if (qParams['user_id']) {
        this.getDonorCardDetails(campaignId, qParams['user_id']);
      }
    }
  }
  /**Set the theatre image of the story */
  setTheatreImage() {
    if (this.fundraiser.theater) {
      this.theaterImage = this.fundraiser.theater.cdn_path;
    } else {
      const gallery = this.fundraiser ? this.fundraiser.gallery : [];
      this.theaterImage = gallery && gallery.length ? gallery[0].cdn_path : this.util.defaultBlurImg;
    }
  }
  /**check the length of the array */
  checkLength(arr) {
    return arr && arr.length ? true : false;
  }
  /**
   * Get the currency of the from
   * currency observable
  */
  getCurrency() {
    this.currencySubscription = this.util.currency.subscribe({
      next: (res) => {
        if (res) {
          this.getFundraiser(this.customTag, res);
          this.currency = res;
          this.currencyInfo = this.util.getCurrencyIcon(res);
        }
      }
    });
  }

  getFundriserStatus(data: IFundraiser) {
    this.isFundraiserEnded = this.util.checkFundraiserStatus(data.status_flag, data.end_date);
    if (this.isFundraiserEnded) {
      if (data.raised) {
        this.isSuccessfullyFunded = this.util.checkIfSuccessfullyFunded(data.amount_requested, data.raised.raised);
      }
    }
  }
  /**Set Basic Info */
  setBasicInfo(data: any[]) {
    if (data && data.length) {
      for (const item of data) {
        this.basicInfo[item.info_type] = item.info_1 || '';
      }
      this.vars.basicInfo = this.basicInfo;
      if (this.basicInfo.translation && this.initialTransalation) {
        this.initialTransalation = false;
        this.vars.translateLangArray.next(this.basicInfo.translation.split(','));
        // this.validLanguages = this.basicInfo.translation.split(',');
      }
      this.setCampaigner();
    }
  }
  /**Set the logic of the
   * Campaigner(Owner) and Beneficiary card
   */
  setCampaigner() {
    this.beneficiary = {};
    if (this.fundraiser?.beneficiaryname?.info_1) {
      this.beneficiary = this.fundraiser.beneficiaryname;
    }
    this.vars.beneficiary = this.beneficiary;
  }
  /**Add youtube emabed on demand*/
  addYoutubeEmbed(url) {
    const data = {
      title: this.vars.metaDataOfPage.title,
      desc: this.vars.metaDataOfPage.description,
      videoId: this.util.getYouTubeId(url),
      startDate: this.vars.fundraiser.start_date
    };
    this.seoService.schamObjectForVideos(data);
    const id = this.util.getYouTubeId(url);
    this.videoSrc = 'https://www.youtube.com/embed/' + id;
  }

  /**Scroll to video if you click from banner */
  scrollToVideo(event) {
    if (event) {
      this.youtubeEmbed.nativeElement.scrollIntoView({
        behavior: 'smooth', block: 'center'
      });
    }
  }
  /**Add meta tags */
  addMetaTags() {
    const metaData = this.seoService.stroyPageMetaTags(this.fundraiser);
    this.tags = this.seoService.createTagObject(metaData);
    this.vars.metaDataOfPage = metaData;
    this.seoService.addMetaTags(this.tags);
    this.seoService.updateCanonicalURL(`/stories/` + this.fundraiser.custom_tag);
  }
  /**On window scroll */
  @HostListener('window:scroll', []) onWindowScroll() {
    const _el = document.getElementById('urgentSlide');
    if (_el) {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      _el.style.bottom = st > this.lastScrollTop ? '0' : '65px';
      this.lastScrollTop = st <= 0 ? 0 : st;
    }
  }
  /**Get the name of the beneficiary */
  getFirstName(name: string) {
    return name ? name.split(' ')[0] : '';
  }
  /**In view port */
  inViewPortListner(e, type) {
    if (this.fundraiser && e.visible === true && !this.inViewPort[type] && this.util.isBrowser) {
      this.inViewPort[type] = true;
    }
  }
  /**All API calls */
  /**Get the details of the fundraiser */
  getFundraiser(customTag, currency) {
    const qParams = this.actRoute.snapshot.queryParams;
    this.fundraiser = undefined;
    let qParam = `?with=viewmedicalbill;gallery;basicinfo;beneficiaryname;beneficiary.avtar;campaigner.avtar;theater;leaderboard;banktransfer;raised;ctaLabel;`
      .concat(`mediaBeneficiary;storyDescription;storyTitle`)
      .concat(`&currency=${currency}&lang=${this.currentLanguage}&ngo_partner=1&page_type=${this.vars.pageName}`);
    if (qParams?.story_version || qParams?.image_blur_type) {
      qParam = qParam + `&story_version=${qParams?.story_version || qParams?.image_blur_type}`;
    }
    this.fundraiserService.getCampaign(customTag, qParam).subscribe({
      next: (res: any) => {
        this.fundraiser = res.data;
        this.fundraiserService.getCampaign(`${this.fundraiser.custom_tag}/raised`, `?currency=${this.currency}&page_type=${this.vars.pageName}`).subscribe((res2: any) => {
          this.fundraiser.raised = res2.data.raised;
          this.fundraiser.raised.beforeTickrBackers = this.fundraiser.raised ? this.fundraiser.raised.backers : 0;
          this.getFundriserStatus(this.fundraiser);
        });
        if (!this.tickrIsShown) { // This is to maintain tickr does not start again upon currency change
          this.tickrIsShown = true;
        }
        this.addMetaTags();
        this.util.setPageTitle(this.fundraiser?.story_title?.info_1 || this.fundraiser?.title || 'NGO');

        this.vars.fundraiser = res.data;
        this.campaignUrl = this.util.domain_details?.full_url;
        if (this.util.isBrowser) {
          this.getSocialShares();
          this.afterLoggedInChecks(this.fundraiser.id);
          this.getFundraiserUpdates(this.fundraiser.custom_tag, 1);
        }
        this.setTheatreImage();
        this.setBasicInfo(this.fundraiser.basicinfo);
        if (this.fundraiser.video_appeal) {
          this.addYoutubeEmbed(this.fundraiser.video_appeal.path);
        }
        if (this.util.isBrowser) {
          this.pageViewEvent();
        }
        this.campaignVisitTrack();
        this.getFundraiserCommnets(this.customTag);
      },
      error: (errorRes) => {
        this.util.router.navigate(['404'], { queryParamsHandling: 'merge' });
      }
    });
  }

  /**Get fundraiser updates */
  getFundraiserUpdates(customTag, limit) {
    const qParam = `?with=owner.avtar;likesCount&limit=${limit}&orderBy=creation_time&sortedBy=desc`;
    this.fundraiserService.getFundraiserUpdates(customTag, qParam).subscribe((res: any) => {
      this.updates = res.data;
      this.updates.data['facebook'] = {
        label: 'Spread the word',
        count: this.sharedCounts.fb,
        campaign_url: this.util.domain_details?.full_url
      };
      for (let i = 0; i < this.updates.data.length; i++) {
        res.data.data[i].owner['creation_time'] = res.data.data[i].creation_time;
        if (!this.updates.data[i].user_liked) {
          this.updates.data[i].user_liked = { 'status': 0 };
        }
        const qParam1 = `/${this.updates.data[i].id}/comments?limit=5`;
        this.fundraiserService.getFundraiserUpdates(customTag, qParam1).subscribe((res1: any) => {
          this.updates.data[i]['comments'] = res1.data;
          this.vars.getTranslatedJsonObs('Stories.referAFriend.writeSomethingToCheer').subscribe(translateRes => {
            this.updates.data[i]['comments'].placeholder = translateRes + (this.fundraiser?.campaigner?.fname || '');
          });
        });
      }
    });
  }

  /**Get the fundraiser comments */
  getFundraiserCommnets(customTag) {
    const qParam = '?limit=5';
    this.fundraiserService.getFundraiserComments(customTag, qParam).subscribe((res: any) => {
      this.comments = res.data;
    });
  }
  /**Get donor card details */
  getDonorCardDetails(campaignId, userId) {
    const qParam = `?with=donoravtar;comments;activation&donor_entity_details_id=${userId}&sortedBy=desc&orderBy=id`;
    this.fundraiserService.getDonorCardDetails(campaignId, qParam).subscribe((res: any) => {
      this.donationCard = res.data;
      if (res.data && res.data.length) {
        this.isDonated = true;
      }
    });
  }
  /**Get Shary card details */
  getSharyCardDetails(campaignId, userId) {
    const qParam = `?with=donoravtar;comments;activation;donor&donor_entity_details_id=${userId}&sortedBy=desc&orderBy=creation_date`;
    this.fundraiserService.getSharyCardDetails(campaignId, qParam).subscribe((res: any) => {
      this.sharyCard = res.data.orders;
    });
  }
  /**Get social shared os the campaign */
  getSocialShares() {
    this.getFacebookShares();
    // this.getWatsappShare();
  }
  /**Get the fb shared */
  getFacebookShares() {
    const selectedId = this.fbService.getFacebookID();
    const url = `/stories/${this.customTag}&fields=engagement&access_token=${encodeURI(selectedId)}`;
    this.fundraiserService.getFacebookShares(url).subscribe((res: any) => {
      const count = res.engagement.share_count;
      if (!this.isFundraiserEnded) {
        this.sharedCounts = {
          fb: count < 500 ? Math.round(Math.random() * 101 + 800) : count + count * 0.2,
          whatsapp: 0
        };
        // this.sharedCounts.whatsapp = Math.round(count - count * 0.1);
      } else {
        this.sharedCounts.fb = count;
      }
    });
  }
  /**Get Whats app share */
  getWatsappShare() {
    this.sharedCounts.whatsapp = this.fundraiserService.getWhatsappShares();
  }

  pageViewEvent() {
    const pageViewPayload = {
      eventName: 'pageView',
      page_name: this.vars.pageName,
      event_type_id: this.fundraiser.id,
      event_type: 'campaign',
      info_1: this.currency,
      info_3: 'stories'
    };
    this.eventsService.onLoadSystemEvent(pageViewPayload);
    const campaignType = `${this.util.getCampaignTypeFromId(this.fundraiser.parent_cause_id)}`;
    const gtmData = {
      'event': 'productDetail',
      'currency': this.currency,
      'ecommerce': {
        'detail': {
          'actionField': { 'list': `${this.vars.pageName}` }, // actions have an optional list property.
          'products': [{
            'name': `${this.fundraiser.custom_tag}`, // Campaign Name
            'id': `${this.fundraiser.id}`, // Campaign ID.
            'category': campaignType,  // Campaign Type
            'variant': `${this.fundraiser.cause_id}`,
            'dimension5': '', // cd_Fundraiser Attributes
            'dimension7': `${this.fundraiser.cause_id}`, // cd_Campaign Cause ID
            'dimension8': `${this.fundraiser.custom_tag}`, // cd_Campaign Custom Tag
            'dimension9': `${this.fundraiser.id}`, // cd_Campaign ID
            'dimension10': campaignType // cd_Campaign Type
          }]
        }
      }
    };
    this.eventsService.gtmPush(gtmData);
    const claverTap = {
      'Campaign Id': this.fundraiser.id,
      'Page URL': this.util.domain_details?.full_url,
      'Campaign Title': this.fundraiser.title,
      'Browser': this.util.detectBrowser(),
      'Campaign Type': this.util.getCampaignTypeFromId(this.fundraiser.id),
      'Cause ID': this.fundraiser.cause_id,
      'Device Type': this.util.isMobile() ? 'Mobile' : 'Desktop',
      'Campaign image URL': this.fundraiser?.leaderboard?.cdn_path || '',
      'Custom Tag': this.fundraiser?.custom_tag || ''
    };
    this.eventsService.claverTapPush('Campaign Viewed', claverTap);
  }

  /** Track user on load  */
  campaignVisitTrack() {
    const user = this.storage.get('userdata');
    const payload = {
      source: this.vars.pageName
    };
    if (user) {
      this.fundraiserService.campaignVisitTrack(this.fundraiser.id, user.id, payload).subscribe();
    }
  }

  eminentExpand(e) {
    this.eminentVisible = !this.eminentVisible;
  }

  eminentEvent() {
    if (this.eminentExpandEventSend) {
      return;
    }
    const payload = {
      eventName: 'eminentExpanded',
      page_name: this.vars.pageName,
    };
    this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
    this.eminentExpandEventSend = true;
  }

  ngOnDestroy() {
    if (this.currencySubscription) {
      this.currencySubscription.unsubscribe();
    }
    if (this.translateObs) {
      this.translateObs.unsubscribe();
    }
    if (this.actRouteSubs) {
      this.actRouteSubs.unsubscribe();
    }
    this.seoService.removeMetaTags(this.tags);
    this.seoService.removeAmpHtml();
    this.subs.forEach(s => s.unsubscribe());
  }

  /**Open bottom sheet of the verified team messages */
  openBottomSheet(template): void {
    this.bottomSheet.open(template, {
      panelClass: 'bottom-sheet-container'
    });
  }

  getTabIndex(event): void {
    this.tabIndex = event;
  }

}
